export { Loading } from "./Loading.component";
export type { LoadingProps } from "./Loading.model";
